import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from '../components/Complements/SelectForm';
import Title from '../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "../actions/codes";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import { urlVoucher } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
import { sendMobile } from '../functions/mobile';
import { feathersCreateData } from '../services';
import TranviaQR from '../components/Tranvia/TranviaQR';
const VoucherTranviaPayContainer = props => {
    const { classes, balances, user, handleOpenSnack, parameters } = props
    const [codespaginate, setCodesPaginate] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [dialog, setDialog] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [dateStart, setDateStart] = useState(new Date(moment().startOf('month')))
    const [dateEnd, setDateEnd] = useState(new Date(moment().endOf('month')))
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [accountSelected, setAccountSelected] = useState(balances[0])
    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.numeroCuenta)
        }
        return unmount()
    }
    const handleGetDataMovementsBySecuencialAccount = (rows, valuedateStart, valuedateEnd, numberpage, secuencial) => {
        setLoading(true)
        findTransferCore({
            $limit: 10,
            $skip: rows,
            type: {
                $in: [39]
            },
            state: true,
            name: secuencial,
            createdAt: {
                $lte: valuedateEnd,
                $gte: valuedateStart
            }
        }).payload.then(
            response => {
                const { data, total } = response

                convertJsonToData(data, total, numberpage)
                setLoading(false)
            }
        ).catch(
            error => {
                console.log(error)
                setLoading(false)
            }
        )
    }
    const convertJsonToData = (data, total, numberpage) => {
        let resul = [];
        data.forEach(row => {

            try {
                let transfertjson = JSON.parse(row.response);
                resul.push({
                    id: row.id, voucher: row.voucher, documento: row.voucher, name_voucher: row.voucher,
                    request: transfertjson.request ? transfertjson.request : {},
                    responseTranvia: transfertjson.responseTranvia ? transfertjson.responseTranvia : {},

                });

            } catch (error) {
                 console.log(error)
            }

        })
         console.log("TODOS LOS MOVIMIENTOS: ", resul)
        setCodesPaginate(resul)
        getDataViewTable(total, numberpage);

    }
    useEffect(mount, [])
    const handleDateStart = (date) => {
        setDateStart(date)
    }
    const handleDateEnd = (date) => {
        setDateEnd(date)
    }

    const handleSubmit = (val) => {
        // console.log(val)
    }
    // mayor
    const getDataViewTable = (total, numberpage) => {

        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;
        if (residuo > 0) {
            contador++;
        }
        setCount(contador)
        setPage(numberpage)
    }
    const handleAccountFind = (value) => {
        setAccountSelected(value)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.numeroCuenta)

    }

    const handleResendEmailWithVoucher = (row) => {
        let object_send_email_with_voucher = {}
        const { correoElectronico } = user;
        setLoading(true)
        if (row.documento) {
            let TipoServicio = (row.tipoServicio) ? row.tipoServicio : "";
            let Codigo = row.codigo;

            object_send_email_with_voucher = {
                Documento: (row.Documento) ? "voucher_" + row.Documento : "voucher_" + row.documento,
                name_voucher: row.name_voucher,
                Email: correoElectronico,
                DataVoucher: {
                    Documento: row.DocumentoTransaccion,
                    AnioLectivo: row.AnioLectivo,
                    Nivel: row.Nivel,
                    Rubro: row.Rubro,
                    Valor: row.Valor,
                    Fecha: row.Fecha,
                    NombrePagador: row.NombrePagador,
                    NombreInstitucion: row.NombreInstitucion,
                    TipoServicio,
                    Codigo
                },
                Type: 17,
                name: accountSelected.numeroCuenta
            }

        } else {
            if (row.IdentificacionDeudor) {

                object_send_email_with_voucher = {
                    Documento: (row.Documento) ? "voucher_" + row.Documento : "voucher_" + row.name_voucher,
                    Email: correoElectronico,
                    name_voucher: row.name_voucher,
                    DataVoucher: {
                        Documento: row.DocumentoTransaccion,
                        Valor: row.MontoPagar,
                        TipoServicio: row.Servicio,
                        NombreInstitucion: row.NombreInstitucion,
                        Referencia: row.NumeroDeReferencia,
                        Identificacion: row.IdentificacionDeudor,
                        Nombre: row.NombreDeudor,
                        NumeroCliente: row.NroDeCliente,
                        Cliente: row.Cliente,
                        numeroCuentaOrigen: row.NroDeCuenta,
                        Rubros: row.Rubros,
                        Monto: row.Monto,
                        Comision: row.Comision,
                        Fecha: row.FechaPago,
                        Concepto: row.Concepto,
                        UrlFactura: row.UrlFactura,
                        Factura: row.Factura
                    },
                    Type: 29,
                    name: accountSelected.numeroCuenta
                }
            } else {
                object_send_email_with_voucher = {
                    Documento: row.name_voucher,
                    name_voucher: row.name_voucher,
                    Email: correoElectronico,
                    DataVoucher: {
                        Valor: row.MontoPagar,
                        Servicio: row.Servicio,
                        Institucion: row.NombreServicio,
                        Referencia: row.NumeroDeReferencia,
                        Cliente: row.Cliente,
                        numeroCuentaOrigen: row.NroDeCuenta,
                        NumeroCliente: row.NroDeCliente,
                        Fecha: row.FechaPago,
                        Documento: row.DocumentoTransaccion,
                        Concepto: row.Concepto,
                        UrlFactura: row.UrlFactura,
                        Factura: row.Factura,
                        Monto: row.Monto,
                    },
                    Type: 27,
                    name: accountSelected.numeroCuenta
                }
            }
        }
        //console.log(object_send_email_with_voucher)
        sendEmailWithVoucher(object_send_email_with_voucher).payload.then(
            response => {
                // console.log(response)
                setLoading(false)
                handleOpenSnack(response.message, response.type)
            }
        ).catch(
            error => {
                handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
                setLoading(false)
            }
        )
    }
    const onChangePaginationCodes = (e, numberpage) => {

        handleGetDataMovementsBySecuencialAccount((numberpage - 1) * 10, dateStart, dateEnd, numberpage, accountSelected.numeroCuenta);
    }
    //handle
    const handleSelectCode = (val) => {
        // console.log(val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)

        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes', obj.month)
            let selectMonth = new Date(obj.year, obj.month, 1)

            setDateStart(moment(selectMonth).startOf('month'))
            setDateEnd(moment(selectMonth).endOf('month'))
            //filterCodesByDate(dateStart, dateEnd, allcodes)
            setDateValue(val)
            setLoading(false)
            handleGetDataMovementsBySecuencialAccount(0, new Date(moment(selectMonth).startOf('month')), new Date(moment(selectMonth).endOf('month')), 1, accountSelected.codigo)
        }

    }
    const handleFindRange = () => {

        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, accountSelected.numeroCuenta)

    }
    const handleViewVoucher = (row) => {
         console.log("TICKET SELECCIONADO: ", row)
        setDialog({
            open: true, title: 'Comprobante',
            children: <TranviaQR
                onlyData={20}
                landscape={true}

                amount={row.responseTranvia.data.ticket.total}
                titleone={"Ticket Virtual Tranvia"}
                titleheader={"Valor Cancelado"}
                titlebuttonnew={"Nuevo Ticket"}
                tarifas={row.request.ticket}
                databodyone={[
                    {
                        title: "Ticket #",
                        value: row.responseTranvia.data.Id_transaccion_municipio_ticket,
                        order: 1
                    },
                    {
                        title: "Desde",
                        value: row.responseTranvia.data.fecha_hora_inicio_vigencia,
                        order: 2
                    },
                    {
                        title: "Hasta",
                        value: row.responseTranvia.data.fecha_hora_fin_vigencia,
                        order: 3
                    },

                ]}
                responseTranvia={row.responseTranvia.data}
                textButtonCancel={"Nueva Transferencia"}
                titletwo={'Información de el ticket'}

                onActionAfter={() => history.push('/')}
                handleCancel={handleCLoseDialog}
                handleDownloadVoucher={() => {
                    try {
                        feathersCreateData('voucher-document', { name: accountSelected.numeroCuenta, document: row.Documento, name_voucher: row.name_voucher })().then(res => {
                            if (res.error) {
                                handleOpenSnack(res.message, 'error')
                            } else {
                                let namefile = res.voucher
                                if (localStorage.cg_app !== undefined) {
                                    let send = {
                                        type: 'action',
                                        action: 'download_voucher',
                                        data: urlVoucher + namefile + ".pdf",
                                        messageSend: 'Comprobante Credito'
                                    }
                                    sendMobile(JSON.stringify(send))
                                } else {
                                    window.open(urlVoucher + namefile + ".pdf", '_blank');
                                }
                            }
                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error'))
                    } catch (error) {
                        console.log(error)
                    }
                }}
                handleDownloadDevice={() => {
                    try {
                        feathersCreateData('voucher-document', { name: accountSelected.numeroCuenta, document: row.Documento, name_voucher: row.name_voucher })().then(res => {
                            if (res.error) {
                                handleOpenSnack(res.message, 'error')
                            } else {
                                let namefile = res.voucher
                                if (localStorage.cg_app !== undefined) {
                                    let send = {
                                        type: 'action',
                                        action: 'export_voucher',
                                        data: urlVoucher + namefile + ".pdf",
                                        nameFile: namefile,
                                        extension: 'pdf',
                                        messageSend: 'Pago de servicios'
                                    }
                                    sendMobile(JSON.stringify(send))
                                } else {
                                    window.open(urlVoucher + namefile + ".pdf", '_blank');
                                }
                            }
                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error'))
                    } catch (error) {
                        console.log(error)
                    }
                }}
                handleSendEmailWithVoucher={() => { handleResendEmailWithVoucher(row) }}
                typesizegrid={12}
            />
        })

    }
    const handleCLoseDialog = () => {
        setDialog({ ...dialog, open: false })
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table className={"table"}>
                            <Thead>
                                <Tr>
                                    <Th>Fecha Inicio Vigencia</Th>
                                    <Th>Fecha Fin Vigencia</Th>
                                    <Th>Ticket</Th>
                                    <Th>Comprobante</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {

                                    codespaginate.map(row => (
                                        (row) &&
                                        <Tr key={`${(row.Documento) ? row.Documento : row.bill}-${(row.Fecha) ? row.Fecha : row.date}`}>
                                            <Td>{row.responseTranvia.data.fecha_hora_inicio_vigencia}</Td>
                                            <Td>{row.responseTranvia.data.fecha_hora_fin_vigencia}</Td>
                                            <Td>{row.responseTranvia.data.Id_transaccion_municipio_ticket}</Td>
                                            <Td><Button variant="contained"
                                                color="primary"
                                                style={{
                                                    fontSize: '0.6rem',
                                                    color: '#1a1919',
                                                    borderLeft: '3px solid #B8992B',
                                                    backgroundColor: "white",
                                                    borderRadius: '0px',
                                                    fontFamily: 'Ubuntu',
                                                    fontWeight: 'bold'
                                                }}
                                                onClick={() => handleViewVoucher(row)}
                                            >Ver</Button></Td>
                                        </Tr>
                                    ))

                                }

                            </Tbody>
                        </Table>
                        <Pagination
                            count={count}
                            color="primary"
                            page={page}
                            onChange={onChangePaginationCodes}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado pago de servicios en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        let _dateStart = new Date(moment().startOf('month'))
        _dateStart.setMonth(_dateStart.getMonth() - 2);
        return <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={8} sm={12}>
                    <Title>Historial Ticket Virtual Tranvia </Title>
                </Grid>
                <Grid item xs={12} md={4} lg={4} sm={12}>

                </Grid>
            </Grid>
            <SelectForm
                name={'Periodo'}
                label={'Seleccione periodo '}
                parameters={parameters}
                // data = { [{ id: '1', name: 'data'}] }
                classes={classes}
                dateValue={dateValue}
                onSelected={(val) => handleSelectCode(val)}
                onSubmit={handleSubmit}
            ></SelectForm>
            <br></br>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3} alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStart}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    maxDate={dateEnd}
                                    maxDateMessage="La fecha de Inicio no debe ser superior a la fecha fin"
                                    minDate={_dateStart}
                                    minDateMessage="La fecha de Inicio no puede ser anterior a los tres meses"
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-end"
                                    label="Fecha de fin"
                                    value={dateEnd}
                                    onChange={handleDateEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    minDate={dateStart}
                                    minDateMessage="La fecha de fin no debe ser anterior a la fecha inicio"
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6}>
                            <Fab color="primary" aria-label="add" onClick={handleFindRange} >
                                <Icon>search</Icon>
                            </Fab>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6}>
                            <Fab color="primary" aria-label="add" onClick={() => history.push('/')} >
                                <Icon>close</Icon>
                            </Fab>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br /> <br />
            <Grid container spacing={3} justify="center" alignItems="center">
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }
    const renderHeader = () => {
        return <div>
            <FormControl variant="outlined" style={{ maxWidth: '100%' }}>
                <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                <Select
                    label="Seleccione una Cuenta"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={balances[0]}
                    onChange={(e) => handleAccountFind(e.target.value)}
                >
                    {
                        balances.map(option => {
                            return <MenuItem key={option.numeroCuenta} value={option}>{`${option.numeroCuenta} - ${option.ProductAlias}`}</MenuItem>
                        })
                    }
                </Select>
            </FormControl>
        </div>
    }
    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                info={renderHeader()}
                multiple={false}
                panel={2}
            />
            <LoadingScreen open={loading} />
            <StandardDialog
                handleClose={handleCLoseDialog}
                open={dialog.open}
                title={dialog.title}>
                {dialog.children}
            </StandardDialog>
        </div>
    );
};
VoucherTranviaPayContainer.propTypes = {
    balances: PropTypes.array.isRequired,
};
export default connect(null, { getCodes, sendEmailWithVoucher, findTransferCore })(VoucherTranviaPayContainer);
//export default VoucherTranviaPayContainer;
